import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { BRAND } from "@/lib/media";
import { useLang } from "@/context/LanguageContext";

export default function PuntaArena() {
  const nav = useNavigate();
  const { t, lang, toggle } = useLang();
  return (
    <div className="relative min-h-screen w-full overflow-hidden noise" data-testid="punta-arena-page">
      <div className="absolute inset-0">
        <img src={BRAND.elArco} alt="El Arco, Cabo San Lucas" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0F2537]/55" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0F2537]/30 via-transparent to-[#0F2537]/85" />
      </div>

      <div className="relative z-10 min-h-screen flex flex-col">
        <header className="px-6 lg:px-12 py-8 flex items-center justify-between">
          <button data-testid="back-to-collection" onClick={() => nav("/")}
            className="flex items-center gap-2 text-[#F6F4F0]/80 hover:text-white transition-colors">
            <ArrowLeft className="w-4 h-4" strokeWidth={1.5} />
            <span className="font-display text-xl tracking-[0.12em]">DERRON LUXURY</span>
          </button>
          <div className="flex items-center gap-6">
            <span className="hidden sm:block overline text-[#F6F4F0]/70">Cabo San Lucas</span>
            <button data-testid="punta-lang-toggle" onClick={toggle} aria-label="Switch language"
              className="text-xs tracking-[0.15em] font-medium text-[#F6F4F0]/80 hover:text-[#E4B58C] transition-colors">
              <span className={lang === "en" ? "text-[#E4B58C]" : ""}>EN</span>
              <span className="mx-1 opacity-40">/</span>
              <span className={lang === "es" ? "text-[#E4B58C]" : ""}>ES</span>
            </button>
          </div>
        </header>

        <div className="flex-1 flex flex-col justify-center items-center text-center px-6 max-w-[1400px] mx-auto w-full pb-20">
          <motion.span initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9 }}
            className="overline text-[#E4B58C] mb-6">{t("The next Derron residence")}</motion.span>
          <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, delay: 0.15 }}
            className="font-display font-light text-white text-6xl sm:text-8xl lg:text-[9rem] leading-[0.9] tracking-tight">
            Punta Arena
          </motion.h1>
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1, delay: 0.5 }}
            className="text-white/85 font-light text-lg max-w-xl mt-8 leading-relaxed">
            {t("An extraordinary new escape rising beside the legendary El Arco of Cabo San Lucas.")}
          </motion.p>
          <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8, delay: 0.7 }}
            className="mt-10 inline-flex items-center gap-3 border border-white/30 rounded-full px-8 py-4">
            <span className="w-2.5 h-2.5 rounded-full bg-[#B86B52] animate-pulse" />
            <span className="font-display text-2xl text-white italic">{t("Coming Soon")}</span>
          </motion.div>
          <motion.button initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8, delay: 0.95 }}
            data-testid="explore-punto-nima" onClick={() => nav("/punto-nima")}
            className="mt-12 px-9 py-4 bg-[#F6F4F0] text-[#0F2537] tracking-wide rounded-sm hover:bg-white transition-colors">
            {t("Meanwhile, explore Punto Nima")}
          </motion.button>
        </div>

        <footer className="px-6 lg:px-12 py-6 text-[#F6F4F0]/50 text-xs tracking-wide text-center">
          © {new Date().getFullYear()} Derron Luxury · Baja California Sur, México
        </footer>
      </div>
    </div>
  );
}
